import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import Moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../../../Actions/AxiosInstance";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../Component/InputValues";
import { ReducersTypes } from "../../../../../../../Constants";
import DAYS_LIST from "../../../../../../../Constants/DATA/daysList";
// import MONTHS_LIST from "../../../../../../../Constants/DATA/monthsList";
// eslint-disable-next-line import/no-cycle
import LeavePlan from "..";
import {
  getSelectValue,
  convertDateForBackend,
} from "../../../../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  isprorate: true,
  proratetypeid: 1,
  creditmodetypeid: 1,
  midjoinstartday: 0,
  isextentionprobation: null,
  creditmonth: null,
  creditday: 0,
  creditdaymonth: null,
  othercreditmodetypeid: 0,
  othercreditmodetype: [],
  creditList: [
    { displayname: "Joining date", displayvalue: 1 },
    { displayname: "Probation end date", displayvalue: 2 },
  ],
};
class ProRate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
    this.getMonth();
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.getMonth();
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          isprorate: props.InitLeavesPolicy.policy[ParentIndex].isprorate,
          proratetypeid:
            props.InitLeavesPolicy.policy[ParentIndex].proratetypeid,
          creditmodetypeid:
            props.InitLeavesPolicy.policy[ParentIndex].creditmodetypeid,
          midjoinstartday:
            props.InitLeavesPolicy.policy[ParentIndex].midjoinstartday,
          isextentionprobation:
            props.InitLeavesPolicy.policy[ParentIndex].isextentionprobation,
          othercreditmodetypeid:
            props.InitLeavesPolicy.policy[ParentIndex].othercreditmodetypeid,
        },
        () => {
          const othercreditmodetype = this.state.othercreditmodetypeid;
          this.setState({ othercreditmodetype });
        },
      );
    } else {
      this.setState({ ...ParentState }, () => this.getMonth());
    }
  }

  setHelperText = (key) => {
    this.props.setHelperText({
      helperText: this.props.Language
        ? this.props.Language.extratimepolicy[key]
        : "",
    });
  };

  getMonth() {
    const { InitLeavesPolicy } = this.props;
    instance.get(`/superuser/getmastercode/Months`).then(
      (result) => {
        const { ParentIndex } = this.state;
        this.setState(
          {
            MonthList: result.data.result,
            creditdaymonth: InitLeavesPolicy.policy[ParentIndex]
              ? InitLeavesPolicy.policy[ParentIndex].creditdaymonth
                ? Moment(
                    InitLeavesPolicy.policy[ParentIndex].creditdaymonth,
                  ).format("YYYY-MM-DD")
                : null
              : null,
          },
          () => {
            if (this.state.creditdaymonth) {
              let { creditdaymonth } = this.state;
              creditdaymonth = creditdaymonth.split("-");
              const creditday = Number(creditdaymonth[2]);
              const creditmonth = Number(creditdaymonth[1]);
              this.setState({ creditday, creditmonth });
            }
          },
        );
      },
      (error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      },
    );
  }

  handleChange(name, ...arg) {
    console.log("name: ", name);
    console.log("arg: ", arg);
    switch (name) {
      case "isprorate":
        this.setState(
          {
            [name]: arg[0],
            proratetypeid: arg[0] == true ? 1 : 3,
            creditmodetypeid: arg[0] == true ? 1 : 3,
            isextentionprobation: false,
            midjoinstartday: 0,
            creditday: 0,
            creditmonth: null,
            creditdaymonth: null,
            othercreditmodetype: null,
            othercreditmodetypeid: 0,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "proratetypeid":
        this.setState(
          {
            [name]: arg[0],
            creditmodetypeid: arg[0] == 1 ? 1 : arg[0] == 4 ? 4 : 3,
            isextentionprobation: false,
            midjoinstartday: 0,
            creditday: arg[0] === 4 ? 1 : null,
            creditmonth: arg[0] === 4 ? 1 : null,
            creditdaymonth: null,
            othercreditmodetype: arg[0] === 4 ? 1 : null,
            othercreditmodetypeid: arg[0] === 4 ? 1 : 0,
          },
          () => this.UpdateReducer(),
        );
        break;
      case "creditmodetypeid":
        this.setState({ [name]: arg[0], midjoinstartday: 0 }, () =>
          this.UpdateReducer(),
        );
        break;
      case "isextentionprobation":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "creditmonth":
        this.setState({ [name]: arg[0].displayvalue }, () => this.createDate());
        break;
      case "creditday":
        this.setState({ [name]: arg[0].displayvalue }, () => this.createDate());
        break;
      case "othercreditmodetype":
        this.setState({ [name]: arg[0].displayvalue }, () =>
          this.options(name, arg),
        );
        break;
      default:
        break;
    }
  }

  options(name, selected) {
    let arg = selected[0];
    arg = arg || null;
    switch (name) {
      case "othercreditmodetype":
        this.setState({ othercreditmodetypeid: arg.displayvalue }, () =>
          this.UpdateReducer(),
        );
        break;
      default:
        break;
    }
  }

  createDate() {
    let { creditday } = this.state;
    let creditmonth = this.state.creditmonth ? this.state.creditmonth : 0;
    let creditdaymonth;
    if (creditday < 10) {
      creditday = `0${creditday}`;
    }
    if (creditmonth < 10) {
      creditmonth = `0${creditmonth}`;
    }
    if (creditday == "00" || creditmonth == "00") {
      creditdaymonth = Moment(`${creditmonth}/${creditday}/1800`);
    } else {
      creditdaymonth = Moment(`${creditmonth}/${creditday}`);
    }
    this.setState({ creditdaymonth }, () => this.UpdateReducer());
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      isprorate: this.state.isprorate,
      proratetypeid: this.state.proratetypeid,
      creditmodetypeid: this.state.creditmodetypeid,
      midjoinstartday: this.state.midjoinstartday,
      isextentionprobation: this.state.isextentionprobation,
      creditdaymonth: convertDateForBackend(this.state.creditdaymonth),
      othercreditmodetypeid: this.state.othercreditmodetypeid,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      switch (name) {
        case "creditday":
          this.setState({ [name]: value }, () => this.createDate());
          break;
        default:
          this.setState({ [name]: value }, () => this.UpdateReducer());
          break;
      }
    }
  };

  render() {
    const language = this.props.Language.prorate;
    const { creditmonth, creditday } = this.state;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="margin-top-20">
          <div className="inner-wrapper opaque">
            <div>
              <p className="form-sub-header">
                <FormattedMessage
                  id="LbCalculateLeaveBalance"
                  defaultMessage="How will the leave balance be calculated?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isprorate", true)}
                aria-expanded={this.state.isprorate}
              >
                <span>
                  <FormattedMessage
                    id="__LbProRate"
                    defaultMessage="Pro-rate"
                  />
                </span>
                {this.state.isprorate == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isprorate}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("proratetypeid", 1)}
                    aria-expanded={this.state.proratetypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="__LbFromJoining"
                        defaultMessage="Pro-rate from joining date"
                      />
                    </span>
                    {this.state.proratetypeid == 1 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.proratetypeid == 1}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 1)}
                        aria-expanded={this.state.creditmodetypeid == 1}
                      >
                        <span>
                          <FormattedMessage
                            id="LbIrrespectiveOfJoining"
                            defaultMessage="Calculate leaves for the joining month, irrespective of joining date"
                          />
                        </span>
                        {this.state.creditmodetypeid == 1 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 2)}
                        aria-expanded={this.state.creditmodetypeid == 2}
                      >
                        <span>
                          <FormattedMessage
                            id="LbEmployeesJoinAfter"
                            defaultMessage="Calculate half month’s leave for joining month, if employee joins after "
                          />
                        </span>
                        {this.state.creditmodetypeid == 2 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div className="et-level4">
                        <Collapse
                          in={this.state.creditmodetypeid == 2}
                          timeout={2}
                          unmountOnExit
                          className="padding20 overflow-initial"
                        >
                          <InputValues
                            min="1"
                            max="28"
                            field="midjoinstartday"
                            onChange={this.CommonNumberChange.bind(
                              this,
                              "midjoinstartday",
                              28,
                            )}
                            value={this.state.midjoinstartday}
                            defaultvalue={this.state.midjoinstartday}
                          />{" "}
                          <span> days </span>
                        </Collapse>
                      </div>
                    </Collapse>
                  </div>
                  <div
                    className="depedent-select-list"
                    onClick={() => this.handleChange("proratetypeid", 2)}
                    aria-expanded={this.state.proratetypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbFromProbation"
                        defaultMessage="Pro-rate from probation end date"
                      />
                    </span>
                    {this.state.proratetypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected " />
                    )}
                  </div>
                  <div className="et-level3">
                    <Collapse
                      in={this.state.proratetypeid == 2}
                      timeout={2}
                      unmountOnExit
                      className="padding30 overflow-initial"
                    >
                      <div
                        className="depedent-select-list"
                        onClick={() =>
                          this.handleChange(
                            "isextentionprobation",
                            !this.state.isextentionprobation,
                          )
                        }
                        aria-expanded={this.state.isextentionprobation}
                      >
                        <span>
                          <FormattedMessage
                            id="LbIncludeExtrendedProbation"
                            defaultMessage="Include extended probation, if any"
                          />
                        </span>
                        {this.state.isextentionprobation ? (
                          <span className="floatright selected-box">
                            <svg width="24" height="24" viewBox="0 0 24 24">
                              <path d="M0 0h24v24H0z" fill="none" />
                              <path
                                d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2
                              2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
                              />
                            </svg>
                          </span>
                        ) : (
                          <span className="not-selected-box" />
                        )}
                      </div>
                      <p className="depedent-select-list-head margin-top-10">
                        <FormattedMessage
                          id="LbCalculateForProbation"
                          defaultMessage="How do we calculate leave for probation (or extended probation) that ends inthe middle of a month?"
                        />
                      </p>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 3)}
                        aria-expanded={this.state.creditmodetypeid == 1}
                      >
                        <span>
                          <FormattedMessage
                            id="LbCalProbationEndMonth"
                            defaultMessage="Calculate leaves for the probation end month"
                          />
                        </span>
                        {/* {this.state.creditmodetypeid == 3 ? ( */}
                        {this.state.proratetypeid == 2 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div
                        className="depedent-select-list"
                        onClick={() => this.handleChange("creditmodetypeid", 4)}
                        aria-expanded={this.state.creditmodetypeid == 2}
                      >
                        <span>
                          <FormattedMessage
                            id="LbEmployeesJoinAfterDateProbation"
                            defaultMessage="Calculate half month’s leave for probation end month, if probation end date is after"
                          />
                        </span>
                        {this.state.creditmodetypeid == 4 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected " />
                        )}
                      </div>
                      <div className="et-level4">
                        <Collapse
                          in={this.state.creditmodetypeid == 4}
                          timeout={2}
                          unmountOnExit
                          className="padding10 overflow-initial"
                        >
                          <InputValues
                            min="1"
                            max="28"
                            field="midjoinstartday"
                            onChange={this.CommonNumberChange.bind(
                              this,
                              "midjoinstartday",
                              28,
                            )}
                            value={this.state.midjoinstartday}
                            defaultvalue={this.state.midjoinstartday}
                          />
                          <span> Days/Date</span>
                        </Collapse>
                      </div>
                    </Collapse>
                  </div>
                </Collapse>
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isprorate", false)}
                aria-expanded={this.state.isprorate == false}
              >
                <span>
                  <FormattedMessage
                    id="__LbDoNotProRate"
                    defaultMessage="Do not pro-rate"
                  />
                </span>
                {this.state.isprorate == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div className="et-level3">
                <Collapse
                  in={this.state.isprorate == false}
                  timeout={2}
                  unmountOnExit
                  className="padding30 overflow-initial"
                >
                  <div
                    className="depedent-select-list"
                    aria-expanded={this.state.proratetypeid == 3}
                  >
                    <span>
                      <FormattedMessage
                        id="LbLeaveIrrespectiveOfJoining"
                        defaultMessage="Don't pro-rate, calculate all leaves irrespective of any joining or probation date"
                      />
                    </span>
                    <span onClick={() => this.handleChange("proratetypeid", 3)}>
                      {this.state.isprorate == false &&
                      this.state.proratetypeid != 4 ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected" />
                      )}
                    </span>
                  </div>
                  <div
                    className="depedent-select-list"
                    aria-expanded={this.state.proratetypeid == 4}
                  >
                    <div className="inlindClass" style={{ width: "96%" }}>
                      <FormattedMessage
                        id="LbLeaveIrrespectiveOfJoining"
                        defaultMessage="Don't pro-rate, calculate all leaves irrespective of joining or probation date(s),"
                      />
                      <br />
                      <div className="padding-top-8">
                        <strong>if </strong>employees joins on or before
                      </div>
                      {/* <InputValues
                        min="1"
                        max="28"
                        field="creditday"
                        onChange={this.CommonNumberChange.bind(this, "creditday", 28)}
                        value={this.state.creditday}
                        defaultvalue={this.state.creditday}
                        disabled={this.state.proratetypeid == 2 ? false : true}
                      /> */}
                      <span className="disp-inline-flex width100 margin-top-0">
                        <Select
                          autofocus
                          placeholder="Day"
                          options={DAYS_LIST}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.handleChange.bind(this, "creditday")}
                          value={getSelectValue(DAYS_LIST, creditday)} // this.state.creditday)}
                          isDisabled={this.state.proratetypeid != 4}
                          className=" width25 margin-right-14"
                        />
                        <Select
                          autofocus
                          placeholder="Month"
                          options={this.state.MonthList}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.handleChange.bind(this, "creditmonth")}
                          value={getSelectValue(
                            this.state.MonthList,
                            creditmonth,
                          )}
                          isDisabled={this.state.proratetypeid != 4}
                          className=" width25"
                        />
                      </span>
                      <div className="margin-top-16">
                        <span>
                          <strong>else </strong>for other employees calculate
                          from
                        </span>
                        &nbsp;
                        <span className="width200p">
                          <Select
                            autofocus
                            placeholder="Select"
                            options={this.state.creditList}
                            getOptionLabel={(option) => option.displayname}
                            getOptionValue={(option) => option.displayvalue}
                            onChange={this.handleChange.bind(
                              this,
                              "othercreditmodetype",
                            )}
                            value={getSelectValue(
                              this.state.creditList,
                              this.state.othercreditmodetype,
                            )}
                            isDisabled={this.state.proratetypeid != 4}
                            className="width52"
                          />
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        verticalAlign: "top",
                        margin: "7% 0 0 0",
                        display: "inline",
                      }}
                    >
                      <span
                        onClick={() => this.handleChange("proratetypeid", 4)}
                      >
                        {this.state.proratetypeid == 4 ? (
                          <span className="floatright">
                            <img src={CheckImg} height="20" />
                          </span>
                        ) : (
                          <span className="not-selected" />
                        )}
                      </span>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
ProRate.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ProRate)));
